<div (click)="onButtonClick()" class="sidebar-list-item" [ngClass]="{'active': router.url === item?.url}" [ngStyle]="{'background': 'radial-gradient(33.45% 58.62% at 50.2% 100%, '+item?.color+' 0%, rgba(27, 27, 27, 0.50) 100%)'
    }">
    <img [src]="item.icon" alt="" [ngStyle]="{'filter': 'drop-shadow(1px 1px 10px ' + item?.color + ')'}">
    <button class="list-item-button" id="b1">{{item.name}}</button>
    <i class="fa-solid fa-play" [ngStyle]="{'color':  item?.color }" ></i>
</div>
